import styled from '@emotion/styled'

import theme from 'styles/theme'

export const HeroBox = styled.div`
  margin: 100px auto 0 auto;
  display: none;
  background-color: ${theme.token.var('colors.green.a150')};
  width: calc(100% - 40px);
  border-radius: ${theme.token.var('borderRadius.big')};

  @media (min-width: ${theme.token('breakpoints.lg')}) {
    display: block;
  }

  @media (min-width: 1450px) {
    width: 1440px;
  }
`
export const HeroCopy = styled.p<{ isWhite?: boolean }>`
  text-align: left;
  margin-top: 12px;
  color: ${({ isWhite }) => (isWhite ? theme.token.var('colors.white') : theme.token.var('colors.black'))};
  font-weight: 300;
  text-align: center;

  @media (min-width: ${theme.token('breakpoints.md')}) {
    font-size: ${theme.token.var('fontSizes.lg')};
  }
`

export const StyledForm = styled.form`
  width: 100%;
  display: none;

  @media (min-width: ${theme.token('breakpoints.md')}) {
    display: flex;
  }
`
